(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-signup"] && !window.DesignMode) return;
  try {
    
    if (!document.getElementById('newsletter-wrapper') || window.localStorage.getItem('modal-hidden') || !document.querySelector('#newsletter-wrapper .form--success')) {
      return;
    }

    var wrapper = document.getElementById('newsletter-wrapper');
    var close = document.getElementById('newsletter-close');

    setTimeout(function() {
      document.body.classList.add('js-drawer-open');
      wrapper.classList.add('newsletter-modal');
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          wrapper.classList.add('newsletter-modal-show');
        });
      });
    }, 5000);

    close.addEventListener('click', function() {
      window.localStorage.setItem('modal-hidden', '1');
      wrapper.classList.remove('newsletter-modal');
      document.body.classList.remove('js-drawer-open');
    });

  } catch(e) { console.error(e); }
})();
})();
